import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';

export interface AgreementSection {
	number: number;
	title: string;
	badge: string;
	badgeClass: string;
	content: ReactNode;
}

export const AGREEMENT_SECTIONS: AgreementSection[] = [
	{
		number: 1,
		title: 'Quality & Performance',
		badge: 'Standards',
		badgeClass: 'staff-agreement__badge--purple',
		content: (
			<>
				<div className="mb-2">
					<strong>I agree to:</strong>
				</div>
				<ul>
					<li>Follow the business quality standards</li>
					<li>Deliver clean, neat, and safe work</li>
					<li>Protect clients' hair and comfort</li>
				</ul>
				<div className="mt-3 mb-2">
					<strong>Consequences:</strong>
				</div>
				<ul>
					<li>Commission may be reduced or withheld</li>
					<li>May be required to redo service unpaid</li>
					<li>Repeated issues can lead to termination</li>
				</ul>
			</>
		),
	},
	{
		number: 2,
		title: 'Punctuality & Attendance',
		badge: 'Time',
		badgeClass: 'staff-agreement__badge--green',
		content: (
			<ul>
				<li>Arrive on time and ready for appointments</li>
				<li>Respect clients' scheduled time</li>
				<li>Late/missed appointments may result in commission loss</li>
			</ul>
		),
	},
	{
		number: 3,
		title: 'Professional Behavior',
		badge: 'Conduct',
		badgeClass: 'staff-agreement__badge--orange',
		content: (
			<>
				<ul>
					<li>Be respectful, polite, and professional</li>
					<li>Never be rude, aggressive, or discriminatory</li>
				</ul>
				<div className="staff-agreement__warning-box">
					<ExclamationTriangleIcon className="w-4 h-4 inline mr-1" />
					Unprofessional behavior may result in immediate termination.
				</div>
			</>
		),
	},
	{
		number: 4,
		title: 'Incomplete Services',
		badge: 'Responsibility',
		badgeClass: 'staff-agreement__badge--red',
		content: (
			<ul>
				<li>May forfeit commission for incomplete work</li>
				<li>May be held responsible for refunds or corrections</li>
			</ul>
		),
	},
	{
		number: 5,
		title: 'Training & Salon Rules',
		badge: 'Compliance',
		badgeClass: 'staff-agreement__badge--violet',
		content: (
			<ul>
				<li>Follow the business standards and training</li>
				<li>Use required products as specified</li>
				<li>Respect salon policies and systems</li>
			</ul>
		),
	},
	{
		number: 6,
		title: 'Camera & Quality Monitoring',
		badge: 'QC',
		badgeClass: 'staff-agreement__badge--cyan',
		content: (
			<ul>
				<li>Salon may use cameras for quality review</li>
				<li>Used for training and dispute resolution</li>
			</ul>
		),
	},
	{
		number: 7,
		title: 'Tax Status & 1099',
		badge: 'Taxes',
		badgeClass: 'staff-agreement__badge--purple',
		content: (
			<div className="staff-agreement__tax-box">
				<strong className="block mb-1.5">I understand that:</strong>
				<ul>
					<li>
						I work as an <strong>Independent Contractor (1099)</strong>
					</li>
					<li>I will receive a 1099 tax form at year-end</li>
					<li>
						Taxes will <strong>not</strong> be withheld from payments
					</li>
					<li>I am responsible for paying my own taxes</li>
				</ul>
			</div>
		),
	},
	{
		number: 8,
		title: 'Agreement & Consent',
		badge: 'Signature',
		badgeClass: 'staff-agreement__badge--green',
		content: (
			<p>
				I understand and agree to follow the business standards. I accept accountability for
				quality, punctuality, behavior, and my 1099 tax status.
			</p>
		),
	},
];
